import { selectSelectedRecommendedPackageId } from './selectSelectedRecommendedPackageId';
import { IAppState } from '../../../../../AppModulesWrapper';
import { IRecommendedPackage } from '../types';

export const selectActiveRecommendedPackage = (state: IAppState): IRecommendedPackage | undefined => {
  const activeId = selectSelectedRecommendedPackageId(state);

  return state.servicePickerWidgetV2.recommendedPackages.packages.find(({ id }) => id === activeId);
};
